import React from "react";
import { money } from "@/lib/helpers";
import { useSettings } from "@/context/SettingsContext";
import { cn } from "@/lib/utils";

// États d'une enveloppe du compte carburant, calculés par le serveur (solde recompté à chaque lecture).
export const FUEL_STATE = {
  ok: { label: "Approvisionné", cls: "text-sky-700 bg-sky-100 dark:bg-sky-900/30 dark:text-sky-300" },
  low: { label: "Solde bas", cls: "text-amber-700 bg-amber-100 dark:bg-amber-900/30 dark:text-amber-400" },
  empty: { label: "Vide", cls: "text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400" },
  overdrawn: { label: "À régulariser", cls: "text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400" },
};

export const ENVELOPES = [
  { key: "fuel", label: "Carburant" },
  { key: "service", label: "Frais de service" },
];

// « Carburant — 1 245,00 € » sur la fiche client (couleur selon l'état le plus grave des enveloppes utilisées).
export default function FuelBadge({ account, className, testid }) {
  const { settings } = useSettings();
  const cur = settings?.currency || "EUR";
  if (!account) return null;
  const st = FUEL_STATE[account.state] || FUEL_STATE.ok;
  const txt = account.state === "overdrawn" ? `Carburant — à régulariser (${money(account.total, cur)})` : `Carburant — ${money(account.total, cur)}`;
  return (
    <span className={cn("px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide rounded-full whitespace-nowrap", st.cls, className)} data-testid={testid}>{txt}</span>
  );
}
